export default "__VITE_ASSET__Dtq$L8bW__"